export default __webpack_public_path__ + "static/media/sample_data.05d4e61e.svg";